import { render } from "./WaveHeader.vue?vue&type=template&id=0d7494b7&scoped=true"
import script from "./WaveHeader.vue?vue&type=script&lang=js"
export * from "./WaveHeader.vue?vue&type=script&lang=js"

import "./WaveHeader.vue?vue&type=style&index=0&id=0d7494b7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7494b7"]])

export default __exports__